import React from 'react'
import noDataFoundIcon from '../../../assets/admin/img/no-data-found.png'


export default function NoRowsOverlay() {
  return (
    <div style={{         // increase height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px"
      }}>
      {/* <img src={noDataFoundIcon} style={{width:100}} alt="Data not found" /> */}
      <h3>No data found</h3>
    </div>
  );
};